import React, { useEffect, useState } from "react";
import "./index.css";
import setaBaixo from "../../assets/images/pngs/setaBaixo.png";
import resgatados from "../../assets/images/pngs/resgatados.png";

export default function BarraProgresso({ listaRanking }) {
  const [progresso, setProgresso] = useState();

  useEffect(() => {
    setProgresso(
      (listaRanking[0].quantidadeResgates / listaRanking[0].pontosRecebidos) *
        100
    );
  }, [listaRanking[0].quantidadeResgates, listaRanking[0].pontosRecebidos]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setProgresso((prevProgresso) =>
  //       prevProgresso >= 100 ? 0 : prevProgresso + 0.05
  //     );
  //   }, 1);

  //   return () => clearInterval(intervalId);
  // }, []);

  return (
    <div className="barra-progresso">
      <div className="progress-container">
        <div
          className="indicator"
          style={{
            left: `${progresso < 20 ? 20 : progresso > 70 ? 70 : progresso}%`,
          }}
        >
          <img src={setaBaixo} alt="" />
          <div className="progress-info">
            <div className="points">
              {Math.trunc(
                listaRanking[0].quantidadeResgates / 1000 || 0
              ).toLocaleString("pt-br", {
                minimumFractionDigits: 0,
              })}
            </div>
            <div className="mil-info">
              <div className="mil">mil</div>
              <div className="pontos">pontos</div>
              <img className="imgResgatados" src={resgatados} />
            </div>
          </div>
        </div>
      </div>
      <div
        className="barrinha"
        style={{
          background: `linear-gradient(to right, #ffd30c 0%, #ffd30c ${progresso}%, #fff ${
            progresso > 70 ? 70 : progresso
          }%)`,
        }}
      />
      <div className="points-end right-end">
        <div className="points">
          {Math.trunc(
            listaRanking[0].pontosRecebidos / 1000 || 0
          ).toLocaleString("pt-br", {
            minimumFractionDigits: 0,
          })}
        </div>
        <div className="mil-info">
          <div className="mil">mil</div>
          <div className="pontos">pontos</div>
        </div>
      </div>
      <div className="points-end left-end">
        <div className="points pontos-inicio">0</div>
        <div className="mil-info">
          <div className="pontos pontos-iniico-texto">pontos</div>
        </div>
      </div>
    </div>
  );
}
